import React from "react"
import styled from "styled-components"

import Video from "../Video/Video"
interface MobileStoryItemprops {
  data: any,
  visible: boolean,
  bg: string
}
const MobileStoryItem = ({ data, visible, bg }: MobileStoryItemprops ) => {

  let item;
  if(visible){
    item = <Video videoSrcURL={data.videolink} height="100%" width="100%" />
  } else {
    item = <img src={bg} width="100%" height="100%" />
  }
  

  return (
    <Container>
      <h2>{data.speakerName}</h2>
      <StoryItem>
        {item}
      </StoryItem>
    </Container>
  )
}

const Container = styled.div`
  h2 {
    font-family: ${({ theme }) => theme.fonts.fontFamilyPrimary};
    text-align: center;
  }
`
const StoryItem = styled.div`
  height: 500px;
  width: 100%;
  margin-bottom: 20px;
`

export default MobileStoryItem
